module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


/*****************
 ** WEBPACK FOOTER
 ** external "react-dom"
 ** module id = 13
 ** module chunks = 0
 **/